import { render, staticRenderFns } from "./ClientCustomizer2.vue?vue&type=template&id=4c91abd4&scoped=true&"
import script from "./ClientCustomizer2.vue?vue&type=script&lang=js&"
export * from "./ClientCustomizer2.vue?vue&type=script&lang=js&"
import style0 from "./ClientCustomizer2.vue?vue&type=style&index=0&id=4c91abd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c91abd4",
  null
  
)

export default component.exports